module.exports = __webpack_public_path__ + "static/media/logout-icon.70e49f1d.svg";